function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UzbekistanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_626",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_626)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 15H24V21H0V15Z",
      fill: "#14DC5A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V10.5H0V3Z",
      fill: "#0099B5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M-1.5 10.125H-1.875V10.5V15V15.375H-1.5H25.5H25.875V15V10.5V10.125H25.5H-1.5Z",
      fill: "#F7FCFF",
      stroke: "#C51918",
      strokeWidth: "0.75"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5455 4.8007L11.8085 5.21881L12.019 4.36905L11.313 3.7446H12.2351L12.5444 2.94046L12.9071 3.7446H13.6931L13.0755 4.36905L13.3725 5.21881L12.5455 4.8007ZM8.76715 7.10647L9.50417 6.68835L10.3311 7.10647L10.0342 6.2567L10.6518 5.63225H9.86571L9.50306 4.82811L9.19378 5.63225H8.27165L8.97765 6.2567L8.76715 7.10647ZM6.73241 8.66492L5.99539 9.08303L6.20589 8.23327L5.49989 7.60882H6.42202L6.7313 6.80468L7.09395 7.60882H7.88004L7.26239 8.23327L7.55937 9.08303L6.73241 8.66492ZM9.54661 8.66819L8.80959 9.08631L9.02009 8.23654L8.31409 7.61209H9.23622L9.5455 6.80795L9.90815 7.61209H10.6942L10.0766 8.23654L10.3736 9.08631L9.54661 8.66819ZM12.5466 8.66819L11.8096 9.08631L12.0201 8.23654L11.3141 7.61209H12.2362L12.5455 6.80795L12.9081 7.61209H13.6942L13.0766 8.23654L13.3736 9.08631L12.5466 8.66819ZM11.7672 7.10647L12.5042 6.68835L13.3311 7.10647L13.0342 6.2567L13.6518 5.63225H12.8657L12.5031 4.82811L12.1938 5.63225H11.2716L11.9776 6.2567L11.7672 7.10647ZM14.8096 9.08631L15.5466 8.66819L16.3736 9.08631L16.0766 8.23654L16.6942 7.61209H15.9081L15.5455 6.80795L15.2362 7.61209H14.3141L15.0201 8.23654L14.8096 9.08631ZM15.5042 6.68835L14.7672 7.10647L14.9776 6.2567L14.2716 5.63225H15.1938L15.5031 4.82811L15.8657 5.63225H16.6518L16.0341 6.2567L16.3311 7.10647L15.5042 6.68835ZM14.8085 5.21881L15.5455 4.8007L16.3725 5.21881L16.0755 4.36905L16.6931 3.7446H15.9071L15.5444 2.94046L15.2351 3.7446H14.313L15.019 4.36905L14.8085 5.21881ZM18.5466 8.66819L17.8096 9.08631L18.0201 8.23654L17.3141 7.61209H18.2362L18.5455 6.80795L18.9081 7.61209H19.6942L19.0766 8.23654L19.3736 9.08631L18.5466 8.66819ZM17.7672 7.10647L18.5042 6.68835L19.3311 7.10647L19.0341 6.2567L19.6518 5.63225H18.8657L18.5031 4.82811L18.1938 5.63225H17.2716L17.9776 6.2567L17.7672 7.10647ZM18.5455 4.8007L17.8085 5.21881L18.019 4.36905L17.313 3.7446H18.2351L18.5444 2.94046L18.9071 3.7446H19.6931L19.0755 4.36905L19.3725 5.21881L18.5455 4.8007ZM4.41368 9.18046C4.41368 9.18046 2.60179 8.68904 2.63591 6.87143C2.67003 5.05381 4.5 4.5819 4.5 4.5819C3.75227 4.29875 1.54136 4.6787 1.50055 6.853C1.45973 9.02729 3.71695 9.45563 4.41368 9.18046Z",
      fill: "#F7FCFF"
    })]
  })]
}));
//# sourceMappingURL=Uzbekistan.js.map